<template>
  <Modal
    :open = "open"
    @close="handleCancelButtonClick"
    size="small"
    :hideScrollbar="true"
    :roundedOnMobile="true"
    class="[&_.modal-position]:!px-6"
  >
    <div
      class="m-2 flex flex-col items-center bg-white text-center sm:rounded-lg"
    >
      <div class="flex flex-col items-center justify-center">
        <h2
          class="h-auto px-0 text-left text-xl font-medium text-gray-900 sm:text-xl"
        >
          {{ title }}
        </h2>

        <p class="mt-2 w-full text-left text-base text-gray-800">
          {{ question }}
        </p>
      </div>
      <div class="mt-8 flex w-full flex-row items-center justify-center gap-2">
        <Button
          class="flex items-center justify-center gap-1.5"
          type="button"
          variant="ghost-no-padding"
          tabindex="-1"
          style="width: 8rem !important"
          @click="handleCancelButtonClick"
        >
          <span>{{ cancelText }}</span>
        </Button>
        <Button
          class="flex items-center justify-center gap-1.5"
          type="button"
          tabindex="-1"
          style="width: 8rem !important"
          @click="handleConfirmButtonClick"
        >
          <span>{{ confirmText }}</span>
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script setup>
  import { Button } from '@/components/block/button';
  import {Modal} from "@/components/block/modal";

  import { __ } from '@/helpers';
  const props = defineProps({
    open: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: __('This action cannot be undone'),
    },
    question: {
      type: String,
      default: __('Are you sure you want to delete this?'),
    },
    confirmText: {
      type: String,
      default: __('Yes, delete this'),
    },
    cancelText: {
      type: String,
      default: __('No'),
    }
  });
  const emits = defineEmits(['cancel', 'confirm']);

  function handleCancelButtonClick() {
    emits('cancel');
  }

  function handleConfirmButtonClick() {
    emits('confirm');
  }
</script>
